import { _ as a } from "../lodash-C0q5Qrix.js";
const i = (t, l) => a(t).map((e) => ({
  label: e.alias,
  value: e.code,
  description: e.description,
  type: "dimension"
})).sortBy("label").value().concat(a(l).map((e) => ({
  label: e.alias,
  value: e.code,
  description: e.description,
  disabled: !0,
  type: "dimension"
})).sortBy("label").value()), p = { label: "Date" };
export {
  p as dateOption,
  i as getDimensionOption
};
//# sourceMappingURL=utils.js.map
